/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2025 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IErrorMessage, initPageable } from "@advapacs/common";
import { ICriticalResultDetail, initSearch } from "@src/types/criticalResult";

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: null,
  studiesReport: [],
  pageable: initPageable,
  countTask: null,
  searchState: initSearch,
  countCriticalResult: 0,
};

const criticalResultSlice = createSlice({
  name: "criticalResultReducer",
  initialState,
  reducers: {
    getListStart(state) {
      state.loading = true;
      state.errorMessage = null;
    },
    getListSuccess(state, action) {
      state.loading = false;
      state.entities = action.payload.content;
      state.pageable = action.payload.pageable;
    },
    getListFail(state, action: PayloadAction<IErrorMessage>) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.entities = [];
    },
    getDetailSuccess(state, action: PayloadAction<ICriticalResultDetail>) {
      state.entity = action.payload;
    },
    getDetailFail(state) {
      state.entity = null;
    },
    getStudyReportSuccess(state, action) {
      state.studiesReport = action.payload.content;
    },
    getStudyReportFail(state) {
      state.studiesReport = null;
    },
    clearData(state) {
      state.errorMessage = null;
      state.entities = [];
      state.pageable = initPageable;
      state.searchState = initSearch;
      state.studiesReport = null;
      state.entity = null;
    },
    setErrorMessage(state, action) {
      state.errorMessage = action.payload;
    },
    setSearchState: (state, action) => {
      state.searchState = action.payload;
    },
    resetSearchState(state) {
      state.searchState = initSearch;
    },
    getCountTaskSuccess(state, action) {
      state.loading = false;
      state.countTask = action.payload;
    },
    getCountSuccess(state, action) {
      state.countCriticalResult = action.payload;
    },
    getCountFail(state) {
      state.countCriticalResult = 0;
      state.loading = false;
    },
    setCount(state, action: PayloadAction<number>) {
      state.countCriticalResult = action.payload;
    },
  },
});

export const CriticalResultAction = criticalResultSlice.actions;
// @ts-ignore
export default criticalResultSlice.reducer;
